import { useQueryClient, useMutation } from '@tanstack/react-query';
import { useApi } from '../useApi';
import { toast } from '../../../components/Toast';
import { controlKeys } from './controls.key';

export function useGenerateStatistics() {
  const getApi = useApi();
  const queryClient = useQueryClient();

  const generateStatistics = async (controlId: string) => {
    const api = await getApi();

    const res = await api.controlsGenerateStatistics(controlId);
    return res.data;
  };

  const onSuccess = (data: { wasUpdate: boolean }) => {
    toast.success(data.wasUpdate ? 'Statistik har uppdaterats' : 'Statistik har genererats');
    queryClient.invalidateQueries({ queryKey: controlKeys.all });
  };

  const onError = () => {
    toast.error('Något gick fel');
  };

  const mutation = useMutation(generateStatistics, {
    onSuccess,
    onError,
  });

  return mutation;
}
